import { APIFailureAction, APIRequestAction, APISuccessAction } from "@/mk2/helpers/action";
import { NormalizedResponse } from "@/mk2/helpers/api";

///////////////////////////////////////////////////////////////////
// Fetch blogs popular feed

export type PopularFeedItemToken = string | number;

export const BLOGS_POPULAR_FEED_FETCH_TRIGGER = "BLOGS_POPULAR_FEED_FETCH_TRIGGER";
export interface BlogsPopularFeedFetchTriggerAction {
    readonly type: typeof BLOGS_POPULAR_FEED_FETCH_TRIGGER;
    readonly after: PopularFeedItemToken;
}
export const BLOGS_POPULAR_FEED_FETCH_REQUEST = "BLOGS_POPULAR_FEED_FETCH_REQUEST";
export interface BlogsPopularFeedFetchRequestAction extends APIRequestAction {
    readonly type: typeof BLOGS_POPULAR_FEED_FETCH_REQUEST;
    readonly after: PopularFeedItemToken;
}
export interface BlogsPopularFeedFetchNormalizedResponse extends NormalizedResponse {
    readonly result: {
        complaints: number[];
        feedItems: number[];
    };
}
export const BLOGS_POPULAR_FEED_FETCH_SUCCESS = "BLOGS_POPULAR_FEED_FETCH_SUCCESS";
export interface BlogsPopularFeedFetchSuccessAction extends APISuccessAction<BlogsPopularFeedFetchNormalizedResponse> {
    readonly type: typeof BLOGS_POPULAR_FEED_FETCH_SUCCESS;
    readonly after: PopularFeedItemToken;
    readonly hasMore: boolean;
}
export const BLOGS_POPULAR_FEED_FETCH_FAILURE = "BLOGS_POPULAR_FEED_FETCH_FAILURE";
export interface BlogsPopularFeedFetchFailureAction extends APIFailureAction {
    readonly type: typeof BLOGS_POPULAR_FEED_FETCH_FAILURE;
    readonly after: PopularFeedItemToken;
}

export const blogsPopularFeedFetchTrigger = (
    after?: PopularFeedItemToken,
): BlogsPopularFeedFetchTriggerAction => ({
    type: BLOGS_POPULAR_FEED_FETCH_TRIGGER,
    after,
});
export const blogsPopularFeedFetchApi = {
    request: (after: PopularFeedItemToken): BlogsPopularFeedFetchRequestAction => ({
        type: BLOGS_POPULAR_FEED_FETCH_REQUEST,
        after,
    }),
    success: (
        after: PopularFeedItemToken,
        hasMore: boolean,
        response: BlogsPopularFeedFetchNormalizedResponse,
    ): BlogsPopularFeedFetchSuccessAction => ({
        type: BLOGS_POPULAR_FEED_FETCH_SUCCESS,
        after,
        hasMore,
        response,
    }),
    failure: (after: PopularFeedItemToken, error: string): BlogsPopularFeedFetchFailureAction => ({
        type: BLOGS_POPULAR_FEED_FETCH_FAILURE,
        after,
        error,
    }),
};
